import React from 'react'
import styles from './AboutSection.module.css'
import { useLang } from '../../i18n/LanguageContext'

const PILLAR_COLORS = ['navy', 'orange', 'teal']
const PILLAR_ICONS  = ['⬡', '◈', '⬟']

export default function AboutSection() {
  const { T } = useLang()

  return (
    <section className={`section ${styles.about}`} id="sobre">
      <div className="container">
        <div className={styles.layout}>
          <div className={styles.textCol}>
            <p className="section-label">{T.about.label}</p>
            <h2 className={`section-title ${styles.title}`}>
              {T.about.heading1}
              <br />
              {T.about.heading2}
            </h2>
            <p className={`section-desc ${styles.desc}`}>{T.about.desc}</p>
            <a href="#contato" className={`btn btn-outline-dark ${styles.cta}`}>
              {T.about.cta}
            </a>
          </div>

          <div className={styles.pillarsCol}>
            {T.about.pillars.map((p, i) => (
              <div key={i} className={`${styles.pillar} ${styles[`pillar--${PILLAR_COLORS[i]}`]}`}>
                <div className={styles.pillarIcon} aria-hidden="true">{PILLAR_ICONS[i]}</div>
                <div>
                  <h3 className={styles.pillarTitle}>{p.title}</h3>
                  <p className={styles.pillarDesc}>{p.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  )
}
